<template>
  <Catalogs
    title="Статусы заказчиков"
    create-text="Новый"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'CustomerStatusAdd'"
    :route-edit="'CustomerStatusEdit'"
    :route-view="'CustomerStatusView'"
    :route-path="'/customer_statuses'"
    :can-edit="canEditCustomerStatusCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
   import Catalogs from "../Catalogs.vue";

export default {
  name: "CustomerStatuses",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'customer-status-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'customer-status-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getCustomerStatuses(data);
    },
    canEditCustomerStatusCatalogs() {
      return this.hasPermission([PERM.CATALOG_CUSTOMER_STATUS_EDIT]);
    }
  }
}
</script>

<style>
.customer-status-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.customer-status-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/CustomerStatuses/CustomerStatuses.vue